import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';

const gqlGetCpGroups = gql`
  query getProfessions($where: String, $offset: Int, $limit: Int, $order: String) {
    getProfessions(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
        isActive
      }
      recordCount
    }
  }
`;

// export function useGetCompanyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>) {
//   return ApolloReactHooks.useLazyQuery<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>(GetCompanyTypesDocument, baseOptions);
// }

export function useGetGroupsAsOptionsQuery() {
  return useLazyQuery(gqlGetCpGroups, {
    fetchPolicy: 'cache-first',
  });
}

function useGetGroupsLazyQuery() {
  return useLazyQuery(gqlGetCpGroups, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

export const FieldSelectProfession = ({
  label = 'Επάγγελμα',
  name = 'professionId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      sbLabel={defaultValues?.profession?.name ?? undefined}
      hook={useGetGroupsLazyQuery}
    />
  );
};

